import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Typography, Paper, Box, ThemeProvider } from '@mui/material';

import { digitsFont } from 'theme/blocksportTheme';

import { useStyles } from './styles';

const Timer = (props: any) => {
	const { data, reload, tiny } = props;

	const { classes } = useStyles();

	const [hours, setHours] = useState(data?.timer?.hours);
	const [minutes, setMinutes] = useState(data?.timer?.minutes);
	const [seconds, setSeconds] = useState(data?.timer?.seconds);

	useEffect(() => {
		const myInterval = setInterval(() => {
			if (seconds > 0) {
				setSeconds(seconds - 1);
			}

			if (seconds === 0) {
				if (hours === 0 && minutes === 0) {
					clearInterval(myInterval);
					reload && window.location.reload();
				} else {
					setSeconds(59);

					if (hours >= 0) {
						if (minutes > 0) {
							setMinutes(minutes - 1);
						}
						if (minutes === 1 && hours === 0) {
							setMinutes(0);
							setHours(0);
							setSeconds(59);
						}
						if (minutes === 1 && hours !== 0) {
							setMinutes(59);
							setHours(hours - 1);
						}
					}
				}
			}
		}, 1000);
		return () => {
			clearInterval(myInterval);
		};
	});

	const hoursStr = `${hours}`.length === 1 ? `0${hours}` : hours;
	const minutesStr = `${minutes}`.length === 1 ? `0${minutes}` : minutes;
	const secondsStr = `${seconds}`.length === 1 ? `0${seconds}` : seconds;

	const fullTime = `<span>${hoursStr}</span> : <span>${minutesStr}</span> : <span>${secondsStr}</span>`;

	return (
		<>
			{tiny ? (
				<Box display="inline-block" className={classes.timerTiny}>
					<Typography variant="h3" className={classes.display}>
						{parse(fullTime)}
					</Typography>
				</Box>
			) : (
				<Paper elevation={1} className={classes.newRoot}>
					<Box display="flex" justifyContent="space-around" alignItems="center" className={classes.heading}>
						<Typography>Hours</Typography>
						<Typography>Minutes</Typography>
						<Typography>Seconds</Typography>
					</Box>
					<ThemeProvider theme={digitsFont}>
						<Box display="flex" justifyContent="space-around" alignItems="center">
							<Typography variant="h3" className={classes.display}>
								{parse(fullTime)}
							</Typography>
						</Box>
					</ThemeProvider>
				</Paper>
			)}
		</>
	);
};

Timer.defaultProps = {
	isSeconds: true,
	reload: true,
	isicon: true,
};

export default Timer;
